import { render, staticRenderFns } from "./GoalsPage.vue?vue&type=template&id=356facab&scoped=true&"
import script from "./GoalsPage.vue?vue&type=script&lang=js&"
export * from "./GoalsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356facab",
  null
  
)

export default component.exports